import { Field, ID, Int, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
export class HaulerCustomerUnitId {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  code?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  name?: string

  @Field(() => Int, { nullable: true })
  @Prop({ type: Number })
  sortIndex?: number

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  status?: string
}
